import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import React from 'react';
import { Jumbotron, Button, Row, FormControl, Col, ControlLabel  } from 'react-bootstrap';
import NotificationSystem from 'react-notification-system';
import { SHA256 } from 'crypto-js';
import _ from 'lodash';

import * as appActions from '../../actions/appActions';
import { gettext } from '../../i18n/service.js';
import './AddCardComponent.scss';

class AddCardComponent extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.showFakeExpiryDate = true;

    this.state = {
      service_command: 'TOKENIZATION',
      language: 'en',
      merchant_identifier: 'swfAPnVc',
      access_code: 'Frck0plLzRL5Qp9adJ7u',
      merchant_reference: Math.random().toString(36).slice(2),
      card_security_code: undefined,
      card_number: undefined,
      expiry_date: '0000',
      remember_me: 'YES',
      card_holder_name: undefined,
      signature: undefined,
      return_url: `https://dev-api.dook.sa/api/getPayfortToken/${localStorage.getItem("userId")}`
    };
    _.bindAll(this, ['renderNewCardForm', 'convert', 'submit', 'cancel', 'converExpiryDate', 'hideFakeExpiryDate', 'renderExpiryDates', 'renderTrueForm', 'renderYears', 'renderMonths',
                    'validationBeforeSubmit']);
  }

  componentWillReceiveProps() {
    if(!this.props.loaded)
      this.props.appActions.endSpinner();
  }

  submit(e) {
    e.preventDefault();
    e.stopPropagation();
      const elems = Array.from(e.target.elements);
      let fields = elems.reduce((prev, curr) => {
        if (!curr.name) {
          return prev;
        }
        return prev;
      }, {});
    return true;
    this.props.onSubmit(values);
  }

  cancel() {
    this.props.router.push('/settings');
  }

  renderExpiryDates() {
    let dates = [];
    let year = new Date().getYear()-100;
    let month = new Date().getMonth()+1;

    for(let i = year; i <= year + 5; i++) {
      if(i === year) {
        for(let j = month; j <= 12; j++) {
          if(j < 10)
            dates.push(<option value={`${i}0${j}`}>{`0${j}/${i}`}</option>);
          else
            dates.push(<option value={`${i}${j}`}>{`${j}/${i}`}</option>);
        }
      }
      else {
        for(let j = 1; j <= 12; j++) {
          if(j < 10)
            dates.push(<option value={`${i}0${j}`}>{`0${j}/${i}`}</option>);
          else
            dates.push(<option value={`${i}${j}`}>{`${j}/${i}`}</option>);
        }
      }
    }
    return dates;
  }

  renderYears() {
    let years = [];
    let year = new Date().getYear()-100;

    years.push(<option key={0} selected disabled value={undefined}>{gettext('YEAR')}</option>);

    for(let i = year; i <= year + 10; i++) {
      years.push(<option key={`${i}`} value={`${i}`}>{`${i}`}</option>);
    }

    return years;
  }

  renderMonths() {
    let months = [];
    const month = new Date().getMonth() + 1;

    months.push(<option key={0} selected disabled value={undefined}>{gettext('MONTH')}</option>);

    for(let i = 1; i <= 12; i++) {
      if(i < 10)
        months.push(<option key={`0${i}`} value={`0${i}`}>{`0${i}`}</option>);
      else
        months.push(<option key={`${i}`} value={`${i}`}>{`${i}`}</option>);
    }

    return months;
  }

  converExpiryDate(date, type) {
    let newDate = this.state.expiry_date;

    if(type==='month') {
      newDate =  newDate.substr(0,2) + date;
    } else if(type==='year') {
      newDate = date + newDate.substr(2,3);
    }

    this.setState({expiry_date: newDate});
  }

  hideFakeExpiryDate() {
    this.showFakeExpiryDate = false;
    this.forceUpdate();
  }

  convert() {
    const signature = 'PASS'+'access_code='+ this.state.access_code
                      +'language='+ this.state.language
                      +'merchant_identifier='+ this.state.merchant_identifier
                      +'merchant_reference='+ this.state.merchant_reference
                      +'return_url='+ this.state.return_url
                      +'service_command='+ this.state.service_command+'PASS';

    this.setState({signature: SHA256(signature).toString()});
  }

  showMessage(opts) {
    if (!this._notificationSystem) {
      return;
    }    
    this._notificationSystem.addNotification(opts);
  }

  validationBeforeSubmit(e) {
    if(!this.state.card_number) {
      e.preventDefault();
      return this.props.showMessage({
        message: gettext('INSERT-CARD-NUMBER'),
        level: 'error'
      });
    }
    
    if(this.state.expiry_date.substr(2,3)==='00') {
      e.preventDefault();
      return this.props.showMessage({
        message: gettext('CHOSE-MONTH'),
        level: 'error'
      });
    }

    if(this.state.expiry_date.substr(0,2)==='00') {
      e.preventDefault();
      return this.props.showMessage({
        message: gettext('CHOSE-YEAR'),
        level: 'error'
      });
    }

    if(!this.state.card_security_code) {
      e.preventDefault();
      return this.props.showMessage({
        message: gettext('INSERT-CVV'),
        level: 'error'
      });
    }

    if(!this.state.card_holder_name) {
      e.preventDefault();
      return this.props.showMessage({
        message: gettext('INSERT-CARD-HOLDER-NAME'),
        level: 'error'
      });
    }

    localStorage.setItem('addCard', 1);
  }

  renderTrueForm() {
    return (
      <form
        onSubmit={(e) => this.validationBeforeSubmit(e)}
        action="https://sbcheckout.PayFort.com/FortAPI/paymentPage"
        method="post">
          <input type="hidden" value={this.state.card_number} name="card_number" />
          <input type="hidden" value={this.state.card_security_code} name="card_security_code" />
          <input type="hidden" value={this.state.card_holder_name} name="card_holder_name" />
          <input type="hidden" value={this.state.expiry_date} name="expiry_date" />
          <input type="hidden" value={this.state.service_command} name="service_command" />
          <input type="hidden" value={this.state.merchant_identifier} name="merchant_identifier" />
          <input type="hidden" value={this.state.access_code} name="access_code" />
          <input type="hidden" value={this.state.merchant_reference} name="merchant_reference" />
          <input type="hidden" value={this.state.language} name="language" />
          <input type="hidden" value={this.state.return_url} name="return_url" />
          <input type="hidden" value={this.state.signature} name="signature" />
          <input type="hidden" value={this.state.remember_me} name="remember_me" />

        <div className="actions">
          <Button type="submit" onClick={() => this.convert()} bsStyle="primary">{gettext('ADD')}</Button>
          <Button bsStyle="danger" onClick={() => this.cancel()}>{gettext('CANCEL')}</Button>
        </div>
      </form>
    );
  }

  renderNewCardForm() {
    return (
      <Jumbotron className="position_relative">
        <NotificationSystem ref={(it) => {
            if (!it || this._notificationSystem) {
              return;
            }
            this._notificationSystem = it;
          }} />
        <Row>
          <div className="user_data center_div">
            <span className="one_dollar_msg">{gettext('ONE-DOLLAR-MSG')}</span>
            <Row className="center_flex">
              <Col sm={9}>
                <ControlLabel><h4>{gettext('CARD-NUMBER')}</h4></ControlLabel>
                <FormControl
                    type="number"
                    required={true}
                    value={this.state.card_number}
                    onChange={(e) => {
                      if(e.target.value.length<=16)
                      this.setState({card_number: e.target.value});
                    }}
                    name="card_number"
                    maxLength={16}
                    placeholder={gettext('CARD-NUMBER')}/>
              </Col>
            </Row>
            <Row className="center_flex">
              <Col sm={9}>
                <Col sm={4} className="zero_padding">
                  <ControlLabel><h4>{gettext('EXPIRY-DATE')}</h4></ControlLabel>
                      <FormControl
                        componentClass="select"
                        required={true}
                        onChange={(e) => {
                          this.converExpiryDate(e.target.value, 'month');
                        }}
                        name="expiry_date">
                        {this.renderMonths()}
                      </FormControl>
                </Col>
                <Col sm={4} className="zero_padding">
                  <ControlLabel><h4>&#x200b;</h4></ControlLabel>
                      <FormControl
                        componentClass="select"
                        className="border_radius_0 left_border_0"
                        required={true}
                        onChange={(e) => {
                          this.converExpiryDate(e.target.value, 'year');
                        }}
                        name="expiry_date">
                        {this.renderYears()}
                      </FormControl>
                </Col>
                <Col sm={4} className="zero_padding">
                  <ControlLabel><h4>{gettext('CVV')}</h4></ControlLabel>
                    <FormControl
                      type="number"
                      required={true}
                      value={this.state.card_security_code}
                      maxLength={3}
                      onChange={(e) => {
                        if(e.target.value.length<=4)
                          this.setState({card_security_code: e.target.value});
                      }}
                      name="card_security_code"
                      placeholder={gettext('CVV')}/>
                </Col>
              </Col>
            </Row>
            <Row className="center_flex">
              <Col sm={9}>
                <ControlLabel><h4>{gettext('CARD-HOLDER-NAME')}</h4></ControlLabel>
                <FormControl
                    type="text"
                    required={true}
                    value={this.state.card_holder_name}
                    onChange={(e) => this.setState({card_holder_name: e.target.value.toUpperCase()})}
                    name="card_holder_name"
                    placeholder={gettext('CARD-HOLDER-NAME')}/>
              </Col>
            </Row>
          </div>
        </Row>
        {this.renderTrueForm()}
      </Jumbotron>
    );
  }

  render() {
    return (
      <div className="new_card_component">
        <div className="item_head_title">
          <h3>{/*gettext('ADD-NEW-CARD')*/}</h3>
        </div>
        {this.renderNewCardForm()}
      </div>
    );
  }
}

AddCardComponent.propTypes = {

};

function mapStateToProps(state) {
  return {
    account: state.appReducer.account,
    loaded: state.appReducer.loaded
  };
}

function mapDispatchToProps(dispatch) {
  return {
    appActions: bindActionCreators(appActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddCardComponent);



// WEBPACK FOOTER //
// ./src/components/cards/AddCardComponent.js